import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex';

@Component({
    computed: mapGetters({
       
    })
})
export default class SearchForm extends Vue {
    @Prop({type:String}) searchText!: string
    
    mSearchText: string = "";

    @Watch('searchText')
    onSearchTextChanged(newVal: string) {
        this.mSearchText = this.searchText;
        this.fnTotalSearch();
    }

    created() {       
        this.mSearchText = this.searchText;
    }

    fnTotalSearch() {
        this.$emit('search', this.mSearchText);
    }
}